import { BUSINESS, SITE_URL } from "../../../data/site"

export const LOCAL_BUSINESS_ID = `${SITE_URL}/#business`

export const buildLocalBusiness = () => ({
  "@context": "https://schema.org",
  "@type": "HealthAndBeautyBusiness",
  "@id": LOCAL_BUSINESS_ID,
  name: BUSINESS.name,
  legalName: BUSINESS.legalName,
  description: BUSINESS.description,
  url: BUSINESS.url,
  logo: BUSINESS.logo,
  image: BUSINESS.logo,
  telephone: BUSINESS.telephone,
  priceRange: BUSINESS.priceRange,
  address: {
    "@type": "PostalAddress",
    addressLocality: BUSINESS.address.addressLocality,
    addressRegion: BUSINESS.address.addressRegion,
    addressCountry: BUSINESS.address.addressCountry,
    ...(BUSINESS.address.streetAddress
      ? { streetAddress: BUSINESS.address.streetAddress }
      : {}),
    ...(BUSINESS.address.postalCode
      ? { postalCode: BUSINESS.address.postalCode }
      : {}),
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: BUSINESS.geo.latitude,
    longitude: BUSINESS.geo.longitude,
  },
  areaServed: BUSINESS.areaServed.map((a) => ({
    "@type": "Place",
    name: a,
  })),
  openingHoursSpecification: BUSINESS.openingHours,
  sameAs: BUSINESS.sameAs,
})
